import {LicensesAndCertifications} from '../model/cv.model';
import {Moment} from 'moment';
import {formatMonthYear} from '../../../shared/utils';
import {BoardAffiliationEntry, BoardAffiliationType} from './board-affiliation-entry.class';
import {OtherCertificationEntry, OtherCertificationType} from './other-certifications-entry.class';
import {Injectable} from '@angular/core';
import {CountryService} from '../../../../domain/model/info/country/country.service';
import {State} from '../../../../domain/model/info/country/state.model';
import {ReplaySubject} from 'rxjs/ReplaySubject';
/**
 * Created by Rodrigo Quesada on 30/03/17.
 */

export class LicensesAndCertificationsInfo {

    medicalLicenses: LicenseEntry[];
    readonly boardAffiliations: BoardAffiliationEntry[];
    readonly boardAffiliationSpecialtyExamination?: BoardAffiliationSpecialtyExaminationInfo;
    readonly otherCertifications: OtherCertificationEntry[];

    private _states: Array<State>;

    private readonly _initializedSubject = new ReplaySubject<boolean>();
    readonly initialized$ = this._initializedSubject.first();

    constructor(lcim: LicensesAndCertificationsInfo.InjectedMembers, model: LicensesAndCertifications) {
        const activeLicenses = model.activeLicenses;
        const inactiveLicenses = model.inactiveLicenses;

        lcim.countryService.getStatesForCountry('US').subscribe(states => {
            this._states = states;

            this.medicalLicenses = activeLicenses.filter(it => it.state && it.state.length > 0).map(it => new LicenseEntry(this._toStateName(it.state!), true))
                .concat(inactiveLicenses ? inactiveLicenses.states.filter(it => it.length > 0).map(it => new LicenseEntry(this._toStateName(it), false)) : [])
                .sort((a, b) => a.compareTo(b));

            this._initializedSubject.next(true);
        });

        const boardAffiliations = model.boardAffiliations;
        this.boardAffiliations = (Stream.of<BoardAffiliationType[]>(
            boardAffiliations.abmsBoard,
            boardAffiliations.abpsBoard,
            boardAffiliations.aoaBoard
        )
            .flatMap(it => it))
            .map(it => new BoardAffiliationEntry(it))
            .sort((a, b) => a.compareTo(b))
            .toArray();

        const specialtyExaminationDate = boardAffiliations.specialtyExaminationDate;
        if (specialtyExaminationDate) this.boardAffiliationSpecialtyExamination = new BoardAffiliationSpecialtyExaminationInfo(specialtyExaminationDate);

        const otherCertifications = model.otherCertifications;
        this.otherCertifications = (Stream.of<OtherCertificationType[]>(
            otherCertifications.lifeCertifications,
            otherCertifications.licensingExaminations,
            otherCertifications.cme
        )
            .flatMap(it => it))
            .map(it => new OtherCertificationEntry(it))
            .sort((a, b) => a.compareTo(b))
            .toArray();
    }

    private _toStateName = (code: string): string => {
        const state = this._states.find(s => s.code === code);
        return state ? state.name : '';
    }
}

class LicenseEntry {
    constructor(readonly state: string, readonly active: boolean) {}

    compareTo(other: LicenseEntry) {
        let order = this._activeOrderValue() - other._activeOrderValue();
        if (order === 0) order = this.state.localeCompare(other.state);

        return order;
    }

    private _activeOrderValue() { return this.active ? 0 : 1; }
}

class BoardAffiliationSpecialtyExaminationInfo {

    readonly name?: string;
    readonly date?: string;

    constructor(date: Moment) {
        this.name = 'Specialty Examination';
        this.date = formatMonthYear(date);
    }
}

// region Injection
export module LicensesAndCertificationsInfo {
    @Injectable()
    export class InjectedMembers {
        constructor(readonly countryService: CountryService) {
        }
    }
}
// endregion



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/cv/download/document/licenses-and-certifications.class.ts